import $ from 'jquery';
import { GridView } from '@component/product-pool-media';
import Panel from './Panel';

const PDP_ZONE_E = 'PDP_ZONE_E';

export default class Grid extends Panel {
  createPanel({ items }) {
    $(this.config.element).addClass('pros-factory-grid');
    if (this.config.zone === PDP_ZONE_E && items.length < 2) {
      this.$el.hide();
      return;
    }
    this.panel = new GridView({
      el: this.config.element,
      model: this.getPanelData(items),
      childView: this.thumbnailView,
    });
  }

  dispatchPixelEvent({ pageIdsPos, currentPage, config }) {
    const that = this;
    const scrollListener = (view) => {
      const windowTop = $(window).scrollTop() + $(window).height();
      const prosPanelTop = (view.$el.offset() && view.$el.offset().top) ? view.$el.offset().top : 0;
      if (windowTop > prosPanelTop) {
        view.prosEventHandler.sendPixelEvent({
          pageIdsPos, currentPage, config,
        });
        view.pixelEventDispatched = true;
      }
    };
    /* istanbul ignore next */
    if (this.properties.pixelPresentedEnabled) {
      scrollListener(this);

      if (!this.pixelEventDispatched) {
        $(window).scroll(() => {
          scrollListener(that);
        });
      }
    }
  }

  onRender(thumbs) {
    super.onRender(thumbs);
    const { currentPage } = this.pagination;
    const pageIdsPos = thumbs.map((thumb) => {
      const { id, position: pos } = thumb.attributes;
      return { id, pos };
    });
    this.dispatchPixelEvent({ pageIdsPos, currentPage, config: this.config });
  }
}
